module.exports = __webpack_public_path__ + "img/pending-receipt.fbe17e45.svg";